import { useGeoContext } from '../contexts/GeoProvider';

// @TODO verify if we need checkout values for this
const useEligibleUSPayment = (): boolean => {
  // const billingAddress = useSelector(getBillingAddressSelector);
  // const shippingAddress = useSelector(getShippingAddressSelector);
  const { countryData } = useGeoContext();
  const countryCode = countryData?.countryCode;
  /**
   * Determine country eligibility
   *
   * If we have either shipping OR billing address
   * eligibility is based on whether they BOTH equal US
   * Otherwise, eligibility is based on whether appCountryCode equals US
   */
  return countryCode === 'US';
};

export default useEligibleUSPayment;
